import InlineTextInput from '@/components/ui/inline-text-input';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehicleInteriorColorEditor = ({
  tradeId,
  initialInteriorColor,
}: {
  tradeId: Trade['id'];
  initialInteriorColor: string;
}) => {
  const [interiorColor, setInteriorColor] = useState(initialInteriorColor);

  const updateInteriorColorMutation = useMutation({
    onMutate: async ({ interiorColor }: { interiorColor: string }) => {
      tradesStore.updateTrade(tradeId, {
        interior_color: interiorColor,
      });
    },
    mutationFn: async ({ interiorColor }: { interiorColor: string }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/interior_color`,
        // /api/trades/:trade_id/interior_color
        {
          interior_color: interiorColor,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating interior color', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handleInteriorColorChange = useCallback(
    debounce((newInteriorColor: string) => {
      updateInteriorColorMutation.mutate({ interiorColor: newInteriorColor });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (interiorColor === initialInteriorColor) return;

    handleInteriorColorChange(interiorColor);
  }, [interiorColor]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setInteriorColor(e.target.value);
  }, []);

  useEffect(() => {
    setInteriorColor(initialInteriorColor);
  }, [initialInteriorColor]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">
          Interior Color
        </div>
      </div>
      <InlineTextInput
        value={interiorColor}
        onChange={onChange}
        placeholder="Enter interior color"
        className="text-right"
        wrapperClassName="gap-1"
      />
    </div>
  );
};

export default TradeVehicleInteriorColorEditor;
